import React from "react";
import { Main } from "@components";
import { AppLayout } from "@layouts";

const IndexPage: React.FC = (): JSX.Element => {
  return (
    <AppLayout>
      <Main />
    </AppLayout>
  )
}

export default IndexPage;
